import type { LucideIcon } from 'lucide-react'
import type React from 'react'
import type { ReactNode } from 'react'

interface SelectedLabelProps {
  // A lucide icon component (rendered directly, in brand colour)
  icon?: LucideIcon
  text?: string | ReactNode // Text or ReactNode content
  className?: string // Additional class names
}

// 12px glyph beside the 12px label: sits on the text's cap height rather than
// over it (lucide draws to the full box, so 16px read ~30% too tall here).
const SelectedLabel: React.FC<SelectedLabelProps> = ({ icon: IconCmp, text, className = '' }) => (
  <div className={`flex items-center gap-1 ${className}`}>
    {IconCmp && <IconCmp size={12} className="text-brand-text" />}
    {text && <span className="text-xs-400">{text}</span>}
  </div>
)

export default SelectedLabel
